import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@appEnv/environment';
import { apiUrls } from '@appEnv/apiurls';
@Injectable({
  providedIn: 'root'
})
export class MolassesDeclarationService {

  constructor(private http: HttpClient) { }
  baseURL = environment.parentUnit;
  devisionUrl = environment.devisionUrl;
  licenseURL = environment.licneseBaseUrl;

  addetails(data): Observable<any> {
    const url = this.baseURL + 'pdMolassesDeclaration';
    return this.http.post(url, data);
  }
  search(payload): Observable<any> {
    const url = this.baseURL + 'pdMolassesDeclaration/lazySearch';
    return this.http.post(url, payload);
  }
  getStatusCountPD(entityType,isCurrentOfficerAllRecords,isAllOfficerRecords,isOtherOfficerAllRecords): Observable<any> {
    const url = this.baseURL + 'pdMolassesDeclaration/getMolassesDeclarationCount?entityType=' + entityType 
    +'&isCurrentOfficerAllRecords=' +isCurrentOfficerAllRecords +'&isAllOfficerRecords=' + isAllOfficerRecords 
    +"&isOtherOfficerAllRecords=" +isOtherOfficerAllRecords ;
    return this.http.get(url);
  }
  getById(id): Observable<any> {
    const url = this.baseURL + 'pdMolassesDeclaration/' + id;
    return this.http.get(url);
  }
  getapplicationnumbers(data): any {
    const url = this.baseURL + 'generateApplicationNumber?registrationType=' + data.registrationType + '&licenseNumber=' + data.licenseNumber;
    return this.http.post(url, {}).toPromise();
  }
  getUnitankList(data): Observable<any> {
    const url = this.baseURL + 'usageTank/dropDown';
    return this.http.post(url, data);
  }
  getTankList(data): Observable<any> {
    const url = this.baseURL + 'breweryTankRegistration/tankRegistrationLazySearch';
    return this.http.post(url, data);
  }

  findpaymentdetails(applicationno, feetype): Observable<any> {
    let url = this.baseURL + 'pdMolassesDeclaration/findPaymentDetails?applicationNumber='+ applicationno + '&feeType=' + feetype;
    return this.http.get(url);
  }

  getMolassesDeclarationCount(entityType): Observable<any> {
    const url = this.baseURL + 'pdMolassesDeclaration/getMolassesDeclarationCount?entityType=' + entityType;
    // const url = 'http://localhost:3501/scmProduction/pdMolassesDeclaration/getMolassesDeclarationCount?entityType=PD';
    return this.http.get(url);
  }
  downloadReportVal(payload) {
    const url = this.baseURL + 'reportReceipt/downloadReceipt'
    //  const url = 'http://localhost:3501/scmProduction/reportReceipt/downloadReceipt';
    return this.http.get(url, { responseType: 'blob', params: payload });
  }
  download(payload){
    const url = this.baseURL + 'reportReceipt/downloadReceipt'
      // const url = 'http://localhost:3501/scmProduction/reportReceipt/downloadReceipt';
    return this.http.get(url,{ responseType: 'blob', params:payload });
  }
  getSugarMillCardCount(payload): Observable<any> {
    const url = this.baseURL + 'sugarMill/getStatusCount'
    return this.http.post(url,payload);
  }

  addDeclarationOfStock(data): Observable<any> {
    const url = this.baseURL + 'stockDeclaration';
    return this.http.post(url, data);
  }
  declarationOfStockSearch(payload): Observable<any> {
    const url = this.baseURL + 'stockDeclaration/lazySearch';
    return this.http.post(url, payload);
  }
  declarationOfStockgetById(id): Observable<any> {
    const url = this.baseURL + 'stockDeclaration/' + id;
    return this.http.get(url);
  }
}
